import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Menu from "@/pages/Menu";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { LanguageProvider } from "@/i18n/LanguageContext";
import LanguageModal from "@/components/LanguageModal";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <LanguageModal />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/o-nas" element={<About />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/kontakt" element={<Contact />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
